var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8851 23.3236C18.9109 23.3236 18.1211 22.5338 18.1211 21.5596L18.1211 12.954C18.1211 11.9797 18.9109 11.1899 19.8851 11.1899C20.8594 11.1899 21.6492 11.9797 21.6492 12.954L21.6492 21.5596C21.6492 22.5338 20.8594 23.3236 19.8851 23.3236Z",
    className: "svg-fill-brand-light"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svg-fill-brand",
    d: "M24.8772 26.6389C24.1883 27.3278 23.0714 27.3278 22.3825 26.6389L18.648 22.9043C17.9591 22.2154 17.9591 21.0985 18.648 20.4096C19.3369 19.7207 20.4538 19.7207 21.1427 20.4096L24.8772 24.1442C25.5661 24.8331 25.5661 25.95 24.8772 26.6389Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7834 8.62823C11.2037 9.86512 6.87513 16.1901 8.10845 22.7508C9.34177 29.3115 15.6717 33.6328 22.2514 32.3959C23.0429 32.2472 23.8052 32.7682 23.954 33.5597C24.1028 34.3512 23.5817 35.1135 22.7902 35.2623C14.6326 36.7958 6.77399 31.4385 5.24212 23.2896C3.71025 15.1408 9.08696 7.29542 17.2446 5.7619C25.4022 4.22839 33.2608 9.5857 34.7927 17.7346C35.3578 20.741 34.9817 23.7108 33.871 26.3356C33.5571 27.0773 32.7014 27.4241 31.9597 27.1102C31.218 26.7963 30.8712 25.9406 31.185 25.1989C32.0792 23.0861 32.3822 20.6982 31.9263 18.2734C30.693 11.7126 24.3631 7.39135 17.7834 8.62823Z",
    className: "svg-fill-brand"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d196db7f2c9a2a38056ef7014b3b1c62.svg";
export { ForwardRef as ReactComponent };